import { useEffect, useRef, useState } from 'react';
import { AiFillThunderbolt } from 'react-icons/ai';
import { SlArrowDown } from 'react-icons/sl';
import { FaUserCircle } from 'react-icons/fa';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FaTag } from 'react-icons/fa';

import SubTaskContent from './SubTaskContent';
import { fullData } from '../../utils/backlogData';
import { getSubTasks } from '../../utils/helper';

const UserStoryContent = ({ data, storyId, sectionId }) => {
  const story = data.issues?.filter((item) => item.id === storyId)[0];
  const {
    fields: { summary, status, assignee },
    key,
  } = story;
  const [storyStatus, setStoryStatus] = useState(status.name);
  const [showStatusOptions, setShowStatusOptions] = useState(false);
  const [showSubTasks, setShowSubTasks] = useState(false);
  const hanldeStatusChange = (status) => {
    setStoryStatus(status);
    setShowStatusOptions(false);
  };
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    isSorting,
  } = useSortable({ id: storyId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const subTasks = getSubTasks(fullData, sectionId, story);
  const statusRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (statusRef.current && !statusRef.current.contains(event.target)) {
        setShowStatusOptions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`flex w-full flex-col justify-center gap-3 border border-zinc-700 bg-zinc-900 px-2 text-gray-50 transition duration-100 hover:bg-zinc-800`}
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={style}
    >
      {/* eslint-disable-next-line */}
      <div
        className={`flex w-full items-center justify-between py-1.5 transition duration-100 hover:text-white`}
        onClick={(e) => {
          e.stopPropagation();
          setShowSubTasks((prev) => !prev);
        }}
      >
        <div className="flex items-center gap-3">
          <button
            className={`${
              !showSubTasks ? '-rotate-90' : 'rotate-0'
            } transition duration-150`}
          >
            <SlArrowDown size={12} />
          </button>
          <span className="rounded-md bg-green-600 p-1">
            <AiFillThunderbolt className="text-white" size={10} />
          </span>
          <span className="text-nowrap text-base font-semibold">{key}</span>
          <div ref={statusRef} className="relative mr-2">
            <button
              className={`flex items-center justify-center gap-1 rounded-3xl px-2 py-0.5 text-[12px] font-semibold uppercase ${
                storyStatus === 'To Do' ? 'bg-[#5652CF]' : 'bg-yellow-500'
              }`}
              onClick={(e) => {
                e.stopPropagation();
                setShowStatusOptions((prev) => !prev);
              }}
            >
              <span className="mt-1">{storyStatus}</span>
              <MdKeyboardArrowDown size={15} className="font-semibold" />
            </button>
            {showStatusOptions && (
              // eslint-disable-next-line
              <div
                className={`absolute ${
                  showStatusOptions ? 'flex' : 'hidden'
                } z-50 flex-col items-center justify-center gap-2 rounded-lg border border-zinc-600 bg-zinc-800 p-2 text-gray-50`}
              >
                {/* eslint-disable-next-line */}
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    hanldeStatusChange('In Progress');
                  }}
                  className="cursor-pointer text-nowrap p-1 text-sm font-semibold hover:text-white"
                >
                  In Progress
                </span>
                {/* eslint-disable-next-line */}
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    hanldeStatusChange('To Do');
                  }}
                  className="cursor-pointer text-nowrap p-1 text-sm font-semibold hover:text-white"
                >
                  To Do
                </span>
              </div>
            )}
          </div>
          <p className="max-w-220px truncate text-base font-semibold">
            {summary}
          </p>
        </div>
        <div className="flex items-center gap-8">
          <span className=" inline-flex h-6 w-6 items-center justify-center rounded-full border border-zinc-700 bg-zinc-500 text-sm font-semibold">
            {subTasks?.length > 0 ? subTasks.length : '-'}
          </span>
          {story.fields?.parent?.fields?.summary && (
            <div className="flex items-center justify-center gap-2 rounded-3xl border border-zinc-600 px-2 py-0.5 text-sm uppercase">
              <FaTag />
              <span className=" max-w-[150px] truncate text-[12px]">
                {story.fields?.parent?.fields?.summary}
              </span>
            </div>
          )}
          {assignee?.displayName && (
            <span className="inline-flex items-center justify-center gap-2 rounded-3xl border border-zinc-600 bg-zinc-950 px-1.5 py-0.5 text-sm">
              <FaUserCircle />
              {assignee?.displayName}
            </span>
          )}
        </div>
      </div>
      {!isDragging && !isSorting && showSubTasks && (
        <div className="flex flex-col px-6 pb-2">
          {subTasks.length > 0 &&
            subTasks.map((subTask) => (
              <SubTaskContent key={subTask.id} subTask={subTask} />
            ))}
        </div>
      )}
    </div>
  );
};

export default UserStoryContent;
